import React, { useState, useEffect, useMemo } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-datepicker/dist/react-datepicker.css";
import DataTable, { TableColumn } from "react-data-table-component";
import { Modal } from "bootstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getAuthToken } from "../../../utils/auth";
import ModelViewer from "../../ModelViewer";
import "../../../style/custommillingHubdashboard.css";
import "../../../style/designer-milling-responsive.css";
import SearchBox from "../../CentralHub/Designer/SearchBox";
import { useRef } from "react";
import SortFilter from "../../CentralHub/Designer/SortFilter";
import { CheckBoxMaster } from "../Designer/Interface/CheckBoxMaster";
import { RejectionReason } from "../Designer/Interface/RejectionReason";
import { ToothDetail } from "../Designer/Interface/ToothDetail";
import { OrderFile } from "../Designer/Interface/OrderFile";
import { OrderRow } from "../Designer/Interface/OrderRow";
import { Order } from "../Designer/Interface/Order";
import { CountdownTimer } from "./CountdownTimer";
import DatePicker from "react-datepicker";
import { apiAxios } from "../../../utils/apiAxios";
import { apiClient } from "../../../api/apiClient";
import { ApiResponse } from "../../../types/ApiResponse";
import signalRService from "../../../services/signalrService";
import AlertSoundManager from "../../../utils/AlertSoundManager";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const API_PATH = process.env.REACT_APP_API_PATH_URL || "";
const DashboardDesignerCentralHub: React.FC = () => {
// const notificationSound = useRef(
//   new Audio("/Notificationsound/notification.mp3")
// );
const notificationSound = useRef<HTMLAudioElement | null>(null);
const querySound = useRef<HTMLAudioElement | null>(null);

useEffect(() => {
  notificationSound.current = new Audio("/Notificationsound/notification.mp3");
  querySound.current = new Audio("/Notificationsound/Query.mp3");
}, []);
  const [actionView, setActionView] = useState<null | "accept" | "reject-scan" | "reject-order">(null);
  const [selectedOrder, setSelectedOrder] = useState<OrderRow | null>(null);
  const [selectedOrderDetail, setselectedOrderDetail] = useState<OrderRow | null>(null);
  const [rejectionNotes, setRejectionNotes] = useState("");
  const [checkBoxList, setCheckBoxList] = useState<CheckBoxMaster[]>([]);
  const [loadingCheckBoxes, setLoadingCheckBoxes] = useState(false);
  const [selectedCheckBoxes, setSelectedCheckBoxes] = useState<number[]>([]);
  const [rejectionReasons, setRejectionReasons] = useState<RejectionReason[]>([]);
  const [loadingReasons, setLoadingReasons] = useState(false);
  const [selectedRejectionReasons, setSelectedRejectionReasons] = useState<number[]>([]);
  const [showReportDelayUI, setShowReportDelayUI] = useState(false);
  const [issueText, setIssueText] = useState("");
  const [reportDelayDateTime, setReportDelayDateTime] = useState<Date | null>(null);
  const [actionLoading, setActionLoading] = useState(false);
  const [designFiles, setDesignFiles] = useState<Record<number, File[]>>({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [activeModalTab, setActiveModalTab] = useState<"order-review" | "actions" | "scan">("order-review");
  const [orders, setOrders] = useState<Order[]>([]);
  const [loading, setLoading] = useState(true);
  const [loadingToothDetails, setLoadingToothDetails] = useState(false);
  const [toothDetails, setToothDetails] = useState<ToothDetail[]>([]);
  const [orderCounts, setOrderCounts] = useState({ activeOrders: 0, pendingReview: 0, needAttention: 0, completed: 0, });
  const [searchText, setSearchText] = useState("");
  const [statusFilter, setStatusFilter] = useState<string | null>(null);
  const latestCaseRequest = useRef<number | null>(null);
  const chatBodyRef = useRef<HTMLDivElement | null>(null);

  const [showQueryModal, setShowQueryModal] = useState(false);
  const [message, setMessage] = useState<string>("");
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [previewUrl, setPreviewUrl] = useState("");
  const [messages, setMessages] = useState<TicketReply[]>([]);
  const [expandedMessages, setExpandedMessages] = useState<Record<number, boolean>>({});

  useEffect(() => {
    const modalEl = document.getElementById("orderDetailsModal");

    if (!modalEl) return;
    const handleModalClose = () => {
      setRejectionNotes("");
      setSelectedRejectionReasons([]);
      setSelectedCheckBoxes([]);
      setDesignFiles({});
      setActionView(null);
    };

    modalEl.addEventListener("hidden.bs.modal", handleModalClose);

    return () => {
      modalEl.removeEventListener("hidden.bs.modal", handleModalClose);
    };
  }, []);
  const handleFileChange = (e: { target: { files: any[]; }; }) => {
    const file = e.target.files?.[0];

    if (file) {
      setSelectedFile(file);

      if (file.type.startsWith("image/")) {
        setPreviewUrl(URL.createObjectURL(file));
      } else {
        setPreviewUrl("");
      }
    }
  };

 useEffect(() => {
  if (!showQueryModal) return;

  const scrollToBottom = () => {
    if (chatBodyRef.current) {
      chatBodyRef.current.scrollTo({
  top: chatBodyRef.current.scrollHeight,
  behavior: "smooth",
});
    }
  };

  // Wait for messages to render
  requestAnimationFrame(scrollToBottom);
}, [showQueryModal, messages]);
useEffect(() => {
  const initSignalR = async () => {

    await signalRService.startConnection("orderChatHub");

    console.log("✅ orderChatHub Connected");

    signalRService.on(
      "orderChatHub",
      "ReceiveMessage",
      (newMessage) => {

       // console.log("ReceiveMessage", newMessage);

        setMessages(prev => {
          const exists = prev.some(x => x.id === newMessage.id);
          if (exists) return prev;
          return [...prev, newMessage];
        });

        fetchAllOrders();

        if (newMessage.senderType !== "Designer") {
          querySound.current!.currentTime = 0;
          querySound.current!.play();
        }
      }
    );

    await signalRService.invoke(
      "orderChatHub",
      "JoinDentistRoom"
    );

    //console.log("✅ Joined Dentist Room");
  };

  initSignalR();

  return () => {
    signalRService.off("orderChatHub", "ReceiveMessage");
  };
}, []);
  const getMessages = async (row: any) => {
    try {

      const response = await apiAxios.get(
        `${API_BASE_URL}/Ticket/GetMessages/${row.orderId}`
      );

      if (response.data.isSuccess) {
        setMessages(response.data.data);

        // Mark as Seen
        if (
          row.ticketId &&
          (row.unreadCount ?? 0) > 0
        ) {
          const formData = new FormData();
          formData.append("TicketId", row.ticketId.toString());
          formData.append("SenderType", "Designer");

          await apiAxios.put(
            `${API_BASE_URL}/Ticket/MarkAsSeen`, formData);
        }
      }

    } catch (error) {
      console.error(error);
    }
  };
  const toggleMessage = (id: number) => {
    setExpandedMessages((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const sendMessage = async () => {
    if (!selectedOrder) return;

    if (
      !message.trim() &&
      !selectedFile
    )
      return;

    const formData = new FormData();

    formData.append("orderId", selectedOrder.orderId);
    formData.append("message", message);
    formData.append("senderType", "Designer");

    if (selectedFile) {
      formData.append("file", selectedFile);
    }

    try {
      const response = await apiClient.post<ApiResponse<any>>(`${API_BASE_URL}/Ticket/SendMessage`, formData);

      if (response.isSuccess) {
        setMessage("");
        setSelectedFile(null);
        //await getMessages(selectedOrder.orderId);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const closeQueryModal = async () => {

    if (selectedOrder?.orderId) {
      await signalRService.invoke(
        "orderChatHub",
        "LeaveOrderRoom",
        {
          orderId: selectedOrder.orderId
        }
      );
    }

    setShowQueryModal(false);
  };

  //------------------------- Chat -----------------------



  const fetchOrderCounts = async () => {
    try {
      const { data } = await apiAxios.get(`/Desginer/GetOrderCounts`);

      if (data.isSuccess && data.data) {
        setOrderCounts({
          activeOrders: data.data[0].activeOrders ?? 0,
          pendingReview: data.data[0].pendingReview ?? 0,
          needAttention: data.data[0].needAttention ?? 0,
          completed: data.data[0].completed ?? 0,
        });
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to load order counts");
    }
  };
  const handleReportDelay = async () => {
    if (!selectedOrder || !issueText.trim() || !reportDelayDateTime) {
      toast.error("Please enter issue details and select date/time");
      return;
    }

    try {
      setActionLoading(true);

      const token = getAuthToken();

      await apiAxios.post(
        `${API_BASE_URL}/Desginer/ReportDesignerDelay`,
        {
          caseID: selectedOrder.caseID,
          delayReason: issueText,
          proposedNewDeliveryTime: reportDelayDateTime.toISOString(),
        },
        {
          headers: { AuthorizationData: token },
        }
      );

      toast.success("Delay reported successfully");

      setShowReportDelayUI(false);
      setIssueText("");
      setReportDelayDateTime(null);

      Modal.getInstance(
        document.getElementById("orderDetailsModal")!
      )?.hide();
    } catch (error) {
      toast.error("Failed to report delay");
    } finally {
      setActionLoading(false);
    }
  };

  useEffect(() => {
    let isMounted = true;

    const loadDashboard = async () => {
      try {
        setLoading(true);
        const ordersData = await fetchAllOrders();
        if (isMounted) {
          
          setOrders(ordersData);
          await fetchOrderCounts();
        }
      } catch (error) {
        console.error("Dashboard load failed:", error);
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    loadDashboard();

    const intervalId = setInterval(loadDashboard, 25000);

    return () => {
      isMounted = false;
      clearInterval(intervalId);
    };
  }, [statusFilter]);
  const fetchAllOrders = async (): Promise<Order[]> => {
    try {
      let url = `/Desginer/GetAllCases`;

      if (statusFilter) {
        url += `?statusFilter=${statusFilter}`;
      }

      const { data } = await apiAxios.get(url);
     // console.log(" Orders API Response:", data);

      if (data.isSuccess && Array.isArray(data.singleData)) {
        return data.singleData;
      }

      return [];
    } catch (err) {
      console.error("Error fetching orders:", err);
      toast.error("Failed to fetch orders");
      return [];
    }
  };
  const fetchToothDetailsByCaseID = async (caseID: number): Promise<ToothDetail[]> => {
    try {
      const { data: result } = await apiAxios.get(`/Desginer/GetCase/${caseID}`);

      if (result.isSuccess) {
        const source =
          result.data?.length ? result.data :
            result.Data?.length ? result.Data :
              result.singleData ? (Array.isArray(result.singleData) ? result.singleData : [result.singleData]) :
                [];

        return source.map((item: any) => ({
          toothNumber: item.toothNumber?.toString() || "",
          materialName: item.materialName || "",
          shadeName: item.shadeName || "",
          material: item.materialName || "",
          shade: item.shadeName || "",
          toothsCount: item.toothNumber?.toString() || "",
          caseDetailID: item.caseDetailID,
          // New fields
          note: item.note || "",
          fileName: item.fileName || "",
          filePath: item.filePath || "",
          fileType: item.fileType || "",
          scanUrl: item.scanUrl || ""
        }));
      }

      return [];
    } catch (err) {
      console.error(`Error fetching tooth details for case ${caseID}:`, err);
      return [];
    }
  };

  const rejectOrder = async (caseID: number, reason: string): Promise<boolean> => {
    try {
      const { data } = await apiAxios.post(`/Desginer/Reject/${caseID}`, {
        rejectReason: reason,
      });

      if (data.isSuccess) {
        toast.success("Scan rejected successfully");
        return true;
      }

      toast.error(data.status || "Rejection failed");
      return false;
    } catch (err: any) {
      toast.error(err.message || "Failed to reject order");
      return false;
    }
  };

  const acceptOrderForDesign = async (caseID: number): Promise<boolean> => {
    try {
      const { data } = await apiAxios.post(`/Desginer/AcceptOrder`, { caseID });

      if (data.isSuccess) {
        AlertSoundManager.stop();
        toast.success("Scan accepted successfully");
        return true;
      }

      toast.error(data.status || "Failed to accept order");
      return false;
    } catch (error: any) {
      toast.error(error.message || "Failed to accept order");
      return false;
    }
  };
  const completeOrder = async (
    caseID: number,
    designFiles: Record<number, File[]>
  ): Promise<boolean> => {
    try {
      const formData = new FormData();
      formData.append("caseId", caseID.toString());

      let index = 0;

      Object.entries(designFiles).forEach(([caseDetailID, files]) => {
        formData.append(`designFiles[${index}].CaseDetailID`, caseDetailID);

        files.forEach((file) => {
          formData.append(`designFiles[${index}].Files`, file);
        });

        index++;
      });

      const { data } = await apiAxios.post(`/Desginer/approve`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (data.isSuccess) {
        toast.success("Order completed successfully");
        return true;
      }

      toast.error(data.status || "Completion failed");
      return false;
    } catch (error: any) {
      toast.error(error.message || "Failed to complete order");
      return false;
    }
  };
  const fetchCheckBoxMaster = async () => {
    try {
      setLoadingCheckBoxes(true);

      const { data } = await apiAxios.get(`/CheckBox/GetAllCheckBoxMaster`);

      if (data.isSuccess && Array.isArray(data.singleData)) {
        setCheckBoxList(data.singleData);
      } else {
        setCheckBoxList([]);
      }
    } catch (error) {
      console.error("Checkbox fetch error:", error);
      toast.error("Failed to load checklist");
    } finally {
      setLoadingCheckBoxes(false);
    }
  };

  const fetchRejectionReasons = async (): Promise<RejectionReason[]> => {
    try {
      setLoadingReasons(true);

      const { data } = await apiAxios.get(`/RejectionReason/GetAll`);

      if (data.isSuccess && Array.isArray(data.singleData)) {
        const activeReasons = data.singleData.filter((r: any) => r.isActive);
        setRejectionReasons(activeReasons);
        return activeReasons;
      }

      return [];
    } catch (err) {
      console.error("Error fetching rejection reasons:", err);
      toast.error("Failed to fetch rejection reasons");
      return [];
    } finally {
      setLoadingReasons(false);
    }
  };
  const loadToothDetails = async (caseID: number) => {
    if (!caseID) return;

    latestCaseRequest.current = caseID;

    setLoadingToothDetails(true);
    setToothDetails([]);

    try {
      const details = await fetchToothDetailsByCaseID(caseID);

      // prevent stale updates
      if (latestCaseRequest.current !== caseID) return;

      setToothDetails(details);
    } catch (error) {
      console.error("Error loading tooth details:", error);

      if (latestCaseRequest.current === caseID) {
        setToothDetails([]);
      }
    } finally {
      if (latestCaseRequest.current === caseID) {
        setLoadingToothDetails(false);
      }
    }
  };

  useEffect(() => {
    if (actionView === "accept") {
      fetchCheckBoxMaster();
    }

    if (actionView === "reject-scan") {
      fetchRejectionReasons();
    }
  }, [actionView]);

  const handleCheckBoxChange = (id: number) => {
    setSelectedCheckBoxes(prev =>
      prev.includes(id)
        ? prev.filter(x => x !== id)
        : [...prev, id]
    );
  };

  const handleRejectionReasonChange = (id: number) => {
    setSelectedRejectionReasons(prev =>
      prev.includes(id)
        ? prev.filter(x => x !== id)
        : [...prev, id]
    );
  };

  const handleRejectScan = async () => {
    try {
      setLoadingReasons(true);
      const selectedReasonNames = rejectionReasons
        .filter(reason => selectedRejectionReasons.includes(reason.rejectionReasonID))
        .map(reason => reason.reasonName);

      let finalRejectionReason = selectedReasonNames.join(", ");
      if (rejectionNotes.trim()) {
        finalRejectionReason += ` - ${rejectionNotes.trim()}`;
      }

      if (finalRejectionReason.trim() === "") {
        toast.error("Please provide a rejection reason");
        return;
      }

      if (!selectedOrder?.caseID) {
        toast.error("Case ID is missing");
        return;
      }
      const success = await rejectOrder(selectedOrder.caseID, finalRejectionReason);

      if (success) {
        setActionView(null);
        setSelectedRejectionReasons([]);
        setRejectionNotes("");

        const modalEl = document.getElementById("orderDetailsModal");
        if (modalEl) {
          const modal = Modal.getInstance(modalEl);
          modal?.hide();
        }

        const ordersData = await fetchAllOrders();
        setOrders(ordersData);
      }
    } catch (error: any) {
      console.error("Reject scan error:", error);
      toast.error(error.message || "Failed to reject order");
    }
    finally {
      setLoadingReasons(false);   // 🔥 loader stop
    }
  };

  const handleCompleteOrder = async () => {
    if (!selectedOrder?.caseID) {
      toast.error("Case ID missing");
      return;
    }

    if (Object.keys(designFiles).length === 0) {
      toast.error("Please upload design files for at least one tooth");
      return;
    }

    try {
      setIsSubmitting(true);

      // ✅ PASS OBJECT, NOT ARRAY
      const success = await completeOrder(
        selectedOrder.caseID,
        designFiles
      );

      if (success) {
        // toast.success("Order completed successfully");


        setDesignFiles({});
        setActiveModalTab("order-review");
        setToothDetails([]);

        const ordersData = await fetchAllOrders();
        setOrders(ordersData);

        const modalEl = document.getElementById("orderDetailsModal");
        if (modalEl) {
          const modal = Modal.getInstance(modalEl);
          modal?.hide();
        }
      }
    } catch (error) {
      console.error("Complete order error:", error);
      toast.error("Something went wrong while completing order");
    } finally {
      setIsSubmitting(false);
    }
  };

  const rejectOrderCompletely = async (
    caseID: number,
    reason: string
  ): Promise<boolean> => {
    try {
      const { data } = await apiAxios.post(
        `/Desginer/cases/${caseID}/reject`,
        {
          reason,
          rejectionType: "DESIGNER_UNAVAILABLE",
        }
      );

      if (data.message === "Case rejection processed successfully.") {
        toast.success(data.message);
        return true;
      }

      toast.error(data.message || "Failed to reject order");
      return false;
    } catch (error: any) {
      console.error("Reject order error:", error);
      toast.error(error.message || "Failed to reject order");
      return false;
    }
  };
  const openFile = (path: string) => window.open(`${API_PATH}${path}`, "_blank");
  const formatFileName = (fileName: string, maxChars = 6) => {
    const dotIndex = fileName.lastIndexOf(".");
    const name = dotIndex !== -1 ? fileName.substring(0, dotIndex) : fileName;
    const ext = dotIndex !== -1 ? fileName.substring(dotIndex) : "";
    if (name.length <= maxChars) return fileName;
    return `${name.substring(0, maxChars)}...${ext}`;
  };


  const handleRejectOrder = async () => {
    if (!selectedOrder?.caseID) {
      toast.error("Case ID missing");
      return;
    }

    if (rejectionNotes.trim() === "") {
      toast.error("Please provide rejection reason");
      return;
    }

    try {
      const success = await rejectOrderCompletely(
        selectedOrder.caseID,
        rejectionNotes.trim()
      );

      if (success) {
        setActionView(null);
        setRejectionNotes("");

        const modalEl = document.getElementById("orderDetailsModal");
        if (modalEl) {
          const modal = Modal.getInstance(modalEl);
          modal?.hide();
        }

        const ordersData = await fetchAllOrders();
        setOrders(ordersData);
      }
    } catch (error) {
      console.error("Reject order error:", error);
    }
  };

  const openModal = () => {
    const modalEl = document.getElementById("orderDetailsModal");

    if (!modalEl) return;

    let modal = Modal.getInstance(modalEl);

    if (!modal) {
      modal = new Modal(modalEl);
    }

    modal.show();
  };


  const handleRowClick = async (row: OrderRow) => {
    setActionView(null);
    setDesignFiles({});
    setActiveModalTab("order-review");

    setSelectedOrder({ ...row });

    await loadToothDetails(row.caseID!);

    requestAnimationFrame(() => {
      openModal();
    });
  };

  const getStatusStyle = (status: string) => {
    switch (status?.toLowerCase()) {

      case "needs attention":
        return { backgroundColor: "#dc3545", color: "#fff" };

      case "on time":
        return { backgroundColor: "#28a745", color: "#fff" };

      case "awaiting response":
        return { backgroundColor: "#fd7e14", color: "#fff" };

      case "scan rejected":
        return { backgroundColor: "#991b1b", color: "#fff" };

      case "re-upload scan":
        return { backgroundColor: "#e35d6a", color: "#fff" };

      case "design overdue":
        return { backgroundColor: "#B45309", color: "#fff" };

      case "done":
        return { backgroundColor: "#479F76", color: "#fff" };

      case "start milling":
        return { backgroundColor: "#6c757d", color: "#fff" };

      case "waiting for design":
        return { backgroundColor: "#c57a0a", color: "#fff" };

      case "in milling":
        return { backgroundColor: "#ffcd39", color: "#fff" };

      case "assigned":
        return { backgroundColor: "#20c997", color: "#fff" };

      case "acceptance overdue":
        return { backgroundColor: "#be123c", color: "#fff" };

      case "in design":
        return { backgroundColor: "#ffcd39", color: "#000" };
      case "delay report":
        return { backgroundColor: "#b45309", color: "#fff" };
      default:
        return { backgroundColor: "#6c757d", color: "#fff" };
    }
  };

  const handleDesignUpload = (
    caseDetailID: number,
    files: FileList | null
  ) => {
    if (!files || files.length === 0) return;

    const fileArray = Array.from(files);

    setDesignFiles(prev => ({
      ...prev,
      [caseDetailID]: fileArray,   // ✅ CORRECT
    }));

    toast.success(`${fileArray.length} file(s) uploaded`);
  };


  const tableData: OrderRow[] = useMemo(() => {
    return orders.map(order => ({
      orderId: order.orderID || "N/A",
      type: order.orderType || "--",
      state: order.underlyingOrderState || "--",
      expectedDelivery: order.expectedDeliveryFormatted || "--",
      status: order.centralHubDesignerTag || "--",
      designerAcceptanceDueOn: order.designerAcceptanceDueOn,
      createdDate: order.createdDate,
      caseID: order.caseID,
      patientName: order.patientName,
      materialName: order.materialName,
      shadeName: order.shadeName,
      toothsCount: order.toothsCount,
      filesList: order.filesList,
      caseDetailID: order.caseDetailID,
      unreadCount: order.unreadCount,
      ticketId: order.ticketId,
      designerApprovedOn: order.designerApprovedOn,
      isScheduled: order.isScheduled,
scheduledDate: order.scheduledDate,
scheduledStartTime: order.scheduledStartTime,
scheduledEndTime: order.scheduledEndTime,
bookingStatus: order.bookingStatus,
    }));
  }, [orders]);

  const conditionalRowStyles = [
    {
      when: (row: any) => row._idx % 2 === 0,
      style: {
        backgroundColor: "#ffffff",
      },
    },
    {
      when: (row: any) => row._idx % 2 !== 0,
      style: {
        backgroundColor: "#ffff",
      },
    },
  ];

  const columns: TableColumn<OrderRow>[] = [
    {
      name: "Order ID",
      selector: (row) => row.orderId,
      sortable: true,
      center: true,
    },
    {
      name: "Type",
      center: true,
      selector: (row) => row.type,
      sortable: true,
    },

    {
      name: "Time Remaining",
      cell: (row) =>
        row.createdDate ? (
          // <CountdownTimer
          //   createdOn={row.createdDate}
          //   status={row.status}
          // />
          <CountdownTimer
            dueOn={row.designerAcceptanceDueOn}
            status={row.status}
          />



        ) : (
          "--"
        ),
      center: true,
    },
    
{
  name: "Schedule",
  center: true,
  minWidth: "220px",
  cell: (row) => {
    if (!row.isScheduled) {
      return <span className="text-muted">--</span>;
    }

    const formatDate = (value?: string | null) => {
      if (!value) return "--";

      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return value;

      return date.toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
    };

    const formatTime = (value?: string | null) => {
      if (!value) return "--";

      const match = value.match(/^(\d{1,2}):(\d{2})/);

      if (!match) return value;

      const hours = Number(match[1]);
      const minutes = Number(match[2]);

      if (hours > 23 || minutes > 59) return value;

      const date = new Date();
      date.setHours(hours, minutes, 0, 0);

      return date.toLocaleTimeString("en-IN", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
    };

    return (
      <div className="text-center py-2">
        <span
          style={{
            display: "inline-block",
            backgroundColor: "#e0f2fe",
            color: "#075985",
            padding: "4px 10px",
            borderRadius: "20px",
            fontSize: "11px",
            fontWeight: 700,
            letterSpacing: "0.4px",
          }}
        >
          {row.bookingStatus || "SCHEDULED"}
        </span>

        <div
          style={{
            marginTop: "5px",
            fontSize: "12px",
            color: "#334155",
            whiteSpace: "nowrap",
          }}
        >
          <i className="bi bi-calendar-event me-1" />
          {formatDate(row.scheduledDate)}
        </div>

        <div
          style={{
            marginTop: "3px",
            fontSize: "12px",
            color: "#475569",
            whiteSpace: "nowrap",
          }}
        >
          <i className="bi bi-clock me-1" />
          {formatTime(row.scheduledStartTime)}
          {" - "}
          {formatTime(row.scheduledEndTime)}
        </div>
      </div>
    );
  },
},

    {
      name: "Status",
      cell: (row) => (
        <span

          style={{
            ...getStatusStyle(row.status),
            padding: "4px 8px",
            borderRadius: "5px",
            fontSize: "13px",

            cursor: "pointer",

            fontWeight: "400",
            textAlign: "center"
          }}
          onClick={async () => {
            setActionView(null);
            setDesignFiles({});
            setActiveModalTab("order-review");

            setSelectedOrder({ ...row });

            await loadToothDetails(row.caseID!);

            requestAnimationFrame(() => {
              openModal();
            });
          }}

        >
          {row.status}
        </span>
      ),
      center: true
    },
    {
      name: "Query",
    cell: (row) => {
  const status = (row.state || "").toLowerCase();

  if (status === "cancelled" || status === "refunded") {
    return null; // or return <span>--</span>;
  }

  return (
    <div
      style={{
        position: "relative",
        display: "inline-block",
      }}
      onClick={async (e) => {
        e.stopPropagation();

        setSelectedOrder(row);

        await signalRService.invoke(
          "orderChatHub",
          "JoinOrderRoom",
          {
            orderId: row.orderId,
          }
        );

        await getMessages(row);

        setShowQueryModal(true);
      }}
    >
      <i
        className="bi bi-chat-dots-fill"
        style={{
          cursor: "pointer",
          fontSize: "18px",
          color: (row.unreadCount ?? 0) > 0 ? "#dc3545" : "#0d6efd",
        }}
      />

      {(row.unreadCount ?? 0) > 0 && (
        <span
          className="badge bg-danger"
          style={{
            position: "absolute",
            top: "-8px",
            right: "-10px",
            minWidth: "18px",
            height: "18px",
            borderRadius: "50%",
            fontSize: "10px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {row.unreadCount}
        </span>
      )}
    </div>
  );
},
      center: true,
      width: "90px",
    }
  ];

  const convertToModelViewerFiles = (files: OrderFile[]) => {
    if (!files || !Array.isArray(files) || files.length === 0) {
      console.warn("No valid files array provided:", files);
      return [];
    }

    return files.map((file) => ({
      name: file.fileName,
      url: getFileUrl(file),
    }));
  };

  const handleReUploadScan = async () => {
    if (!selectedOrder?.caseID) {
      toast.error("Case ID missing");
      return;
    }

    if (Object.keys(designFiles).length === 0) {
      toast.error("Please upload files");
      return;
    }

    try {
      setIsSubmitting(true);

      const success = await reUploadScan(
        selectedOrder.caseID,
        designFiles
      );

      if (success) {
        setDesignFiles({});
        setActiveModalTab("order-review");

        const ordersData = await fetchAllOrders();
        setOrders(ordersData);

        const modalEl = document.getElementById("orderDetailsModal");
        if (modalEl) {
          const modal = Modal.getInstance(modalEl);
          modal?.hide();
        }
      }
    } catch (error) {
      toast.error("Something went wrong");
    } finally {
      setIsSubmitting(false);
    }
  };


  const reUploadScan = async (
    caseID: number,
    designFiles: Record<number, File[]>
  ): Promise<boolean> => {
    try {
      const formData = new FormData();
      formData.append("caseId", caseID.toString());

      let index = 0;

      Object.entries(designFiles).forEach(([caseDetailID, files]) => {
        formData.append(`designFiles[${index}].CaseDetailID`, caseDetailID);

        files.forEach((file) => {
          formData.append(`designFiles[${index}].Files`, file);
        });

        index++;
      });

      const { data } = await apiAxios.post(`/Desginer/ReUploadScan`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (data.isSuccess) {
        toast.success("Scan re-uploaded successfully");
        return true;
      }

      toast.error(data.status || "Re-upload failed");
      return false;
    } catch (error: any) {
      toast.error(error.message || "Failed to re-upload scan");
      return false;
    }
  };
  const filteredData = useMemo(() => {
    if (!tableData) return [];

    return tableData.filter((item) =>
      Object.values(item).some((val) =>
        String(val).toLowerCase().includes(searchText.toLowerCase())
      )
    );
  }, [tableData, searchText]);

  const getFileUrl = (file: OrderFile) => {
    if (file.imagePath.startsWith("http")) return file.imagePath;
    const baseUrl = API_BASE_URL?.endsWith("/api") ? API_BASE_URL.slice(0, -4) : API_BASE_URL;
    return `${baseUrl}${file.imagePath}`;
  };



  const isAwaitingAcceptance =
    selectedOrder?.status === "To be Accepted" ||
    selectedOrder?.status === "Acceptance Overdue" ||
    selectedOrder?.status === "Waiting for acceptance";

  const isInDesign = selectedOrder?.status === "In Design";
  const IsOverdue = selectedOrder?.status === "Design Overdue";
  const isDelayReport = selectedOrder?.status === "Delay Report";
  const isReUploadScan = selectedOrder?.status === "Re-upload Scan";

  const [hasSOS, setHasSOS] = useState(false);

  const [audioEnabled, setAudioEnabled] = useState(false);
  const enableAudio = async () => {
    try {
      await AlertSoundManager.unlock();

      setAudioEnabled(true);
      localStorage.setItem("audioEnabled", "true");

      toast.success("Sound alerts enabled.");
    } catch {
      toast.error("Please allow sound playback.");
    }
  };




  useEffect(() => {
    if (!audioEnabled) return;

    if (hasSOS) {
      AlertSoundManager.play();
    } else {
      AlertSoundManager.stop();
    }
  }, [hasSOS, audioEnabled]);
  

const shouldPlayDesignAlert = (order: any) => {
  if (!order.designerApprovedOn) return false;

  const approvedTime = new Date(order.designerApprovedOn).getTime();
  const now = Date.now();

  const minutesPassed = (now - approvedTime) / (1000 * 60);

  const orderType = (order.orderType || "").toLowerCase();

  // Express orders
  const isExpress =
    orderType.includes("express");

  const threshold = isExpress ? 7 : 15; // use 20 if required

  return minutesPassed >= threshold;
};

  //  useEffect(() => {
  //       const sos = filteredData.some(
  //         x => x.status === "Acceptance Overdue" || x.status==="To be Accepted"
  //       );
    
  //       setHasSOS(sos);
  //     }, [filteredData]);


      useEffect(() => {
  const sos = filteredData.some((order) => {
    // Existing acceptance alert
    if (
      order.status === "Acceptance Overdue" ||
      order.status === "To be Accepted"
    ) {
      return true;
    }
    // Designer approved alert
    return shouldPlayDesignAlert(order);
  });

  setHasSOS(sos);
}, [filteredData]);

  return (
    <>
    {!audioEnabled && (
         <div className="audio-permission-overlay">
  <div className="audio-permission-box">
    <div className="audio-icon">🔔</div>

          <p>
            Click below to allow emergency sound alerts for
            <strong> Needs Attention</strong> orders.
          </p>

          <button
              className="btn btn-danger enable-sound-btn"
            onClick={enableAudio}
          >
            Enable Sound Alerts
          </button>
        </div>
      </div>
    )}
       <div className={`main-header-section-top ${hasSOS ? "dashboard-sos" : ""}`}>
        <div className="container-fluid my-3 p-0">
          <div className="order-status-bar">

            <div className="status-item" onClick={() => setStatusFilter("Active")}>
              <div className="status-count">
                {orderCounts.activeOrders}
              </div>
              <div className="status-text bgnone">
                Active Orders
              </div>
            </div>

            <div className="status-item" onClick={() => setStatusFilter("PendingReview")}>
              <div className="status-count">
                {orderCounts.pendingReview}
              </div>
              <span className="status-badge warning">
                <img src="../../awaiting.png" alt="" className="status-icon" />
                Awaiting Response
              </span>
            </div>

            <div className="status-item" onClick={() => setStatusFilter("NeedAttention")}>
              <div className="status-count">
                {orderCounts.needAttention}
              </div>
              <span className="status-badge danger">
                <img src="../../needsattantion2.png" alt="" className="status-icon" />
                Need Attention
              </span>
            </div>

            <div className="status-item" onClick={() => setStatusFilter("Completed")}>
              <div className="status-count">
                {orderCounts.completed}
              </div>
              <span className="status-badge success">
                <i className="bi bi-check-circle-fill completed-icon"></i>
                Completed
              </span>
            </div>

          </div>

        </div>
</div>
        {/*New Design created by anup 12 jan*/}

        <div className="shadow-container rounded p-3 mt-4">
          <div className="search-button-section  mb-3">
            <SearchBox value={searchText} onChange={setSearchText} />
            <SortFilter />
          </div>

          {loading ? (
            <div className="text-center p-4">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <p className="mt-2">Loading orders...</p>
            </div>
          ) : (


            <DataTable<OrderRow>
              columns={columns}
              data={filteredData}
              pagination
              highlightOnHover
              pointerOnHover
              conditionalRowStyles={conditionalRowStyles}
              noDataComponent="No orders found"
              paginationPerPage={10}
              paginationRowsPerPageOptions={[10, 20, 30]}
              onRowClicked={handleRowClick}

            />
          )}
        </div>
        <div
          className="modal fade" id="orderDetailsModal" tabIndex={-1} aria-hidden="true" style={{ backgroundColor: "rgba(0,0,0,0.3)" }}>
          <div className="modal-dialog modal-dialog-centered only-desktop-center" style={{ maxWidth: "980px" }}>
            <div className="modal-content custom-modal-padding15px" style={{ minHeight: "580px" }}>
              <div className="modal-header manager-modal-header">
                <h6 className="modal-title">
                  Order ID: {selectedOrder?.orderId || "--"}
                  {selectedOrder?.caseID && <span className="ms-2 text-muted"></span>}
                </h6>



                <button
                  type="button"
                  className="btn-close custom-close-btn"
                  data-bs-dismiss="modal"
                  aria-label="Close" onClick={() => {
                    setToothDetails([]);
                    setLoadingToothDetails(false);
                  }}
                ><i className="bi bi-x customcross"></i></button>
              </div>

              <div className="modal-body p-0">
                <div className="d-flex justify-content-between px-3 py-1">
                  {activeModalTab === "order-review" ? (
                    <>
                      <div className="dentist-approval">{selectedOrder?.status}</div>
                      {selectedOrder?.createdDate && (
                        <CountdownTimer
                          dueOn={selectedOrder?.designerAcceptanceDueOn}
                          createdOn={selectedOrder?.createdDate} // fallback
                          status={selectedOrder?.status}
                        />


                      )}

                    </>
                  ) : (
                    <>
                      <div className="dentist-approval">{selectedOrder?.status}</div>
                      {selectedOrder?.createdDate && (
                       <CountdownTimer
  dueOn={selectedOrder?.designerAcceptanceDueOn}
  createdOn={selectedOrder?.createdDate}
  status={selectedOrder?.status}
/>

                      )}

                    </>
                  )}
                </div>

                                <div className="d-flex  Actions-text-part2 border-bottom mx-3 order-details-tab-link pt-2 top-order-tabssection order-detail-bottom-border">      <a
                    className={` btn-link pop-upbtn-link mx-1 px-0 border-bottom-second me-4 ${activeModalTab === "order-review"
                      ? "fw-semibold text-primary border-2"
                      : "text-muted"
                      }`}
                    onClick={() => setActiveModalTab("order-review")}
                  >
                    Order Details
                  </a>
                  <a
                    className={` btn-link pop-upbtn-link px-0 border-bottom-second mx-5 text-muted ${activeModalTab === "scan"
                      ? "fw-semibold text-primary border-2"
                      : "text-muted"
                      }`}
                    onClick={() => setActiveModalTab("scan")}
                  >
                    Scan
                  </a>

                  <a
                    className={` btn-link mx-4 pop-upbtn-link px-0 ${activeModalTab === "actions"
                      ? "fw-semibold text-primary border-2"
                      : "text-muted"
                      }`}
                    onClick={() => setActiveModalTab("actions")}
                  >
                    Actions
                  </a>
                </div>

                {activeModalTab === "order-review" && (
                  <div className="row g-0">
                     <div className="col-md-12 col-lg-9 p-3 col-12">
                         <div className="milling-table-wrapper">
  <table className="table table-borderless milling-custom-table">
                        <thead>
                          <tr>
                            <th>Tooth</th>
                            <th>Material</th>
                            <th>Shade</th>
                            <th>Design</th>
                          </tr>
                        </thead>
                        <tbody>
                          {loadingToothDetails ? (
                            <tr>
                              <td colSpan={4} className="text-center">
                                <span className="spinner-border spinner-border-sm me-2" role="status">
                                  <span className="visually-hidden">Loading...</span>
                                </span>
                                Loading tooth details...
                              </td>
                            </tr>
                          ) : toothDetails.length > 0 ? (
                            toothDetails.map((tooth, index) => (
                              <tr key={index}>
                                <td>{tooth.toothNumber || "--"}</td>
                                <td>{tooth.materialName || tooth.material || "--"}</td>
                                <td>{tooth.shadeName || tooth.shade || "--"}</td>
                                <td>

                                  <td>
                                    {!(isInDesign || isReUploadScan || isDelayReport || IsOverdue) ? (
                                      "--"
                                    ) : (
                                      <div className="margin-andpadding-left0">
                                        {!designFiles[tooth.caseDetailID]?.length && (
                                          <>
                                            <label
                                              htmlFor={`design-upload-${tooth.caseDetailID}`}
                                              className="btn btn-sm btn-secondary Upload-Approve-btn"
                                              style={{ cursor: "pointer" }}
                                            >
                                              Upload
                                            </label>

                                            <input
                                              type="file"
                                              id={`design-upload-${tooth.caseDetailID}`}
                                              accept=".jpg,.jpeg,.png,.pdf,.stl,.zip"
                                              multiple
                                              style={{ display: "none" }}
                                              onChange={(e) =>
                                                handleDesignUpload(tooth.caseDetailID, e.target.files)
                                              }
                                            />
                                          </>
                                        )}

                                        {designFiles[tooth.caseDetailID]?.length > 0 && (
                                          <div className="scrollable-td text-truncate">
                                            <ul className="mt-2 list-custom-section designer-image-list text-start imageloaded-stlfile-padding-right-file">
                                              {designFiles[tooth.caseDetailID].map((file, idx) => (
                                                <li key={idx} className="imageloaded-stlfile-padding-right2 file-ellipsis" >{file.name}</li>
                                              ))}
                                            </ul>
                                          </div>
                                        )}
                                      </div>
                                    )}
                                  </td>


                                </td>



                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={4} className="text-center">
                                No tooth details found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                       </div>

                    <div className="col-md-12 col-lg-3 col-12 mt-3 border-start p-3">
                      <p className="scans-fontweight500">Scans (By Dentist)</p>

                      {selectedOrder?.filesList && selectedOrder.filesList.length > 0 ? (
                        selectedOrder.filesList.map((file, index) => (
                          <div key={file.fileID} className="d-flex justify-content-between align-items-center mt-2 px-2 py-1 border rounded">
                            <span
                              className="text-truncate"
                              style={{ cursor: "pointer" }}
                              title={file.fileName}
                              onClick={() => openFile(file.imagePath)}
                            >
                              {formatFileName(file.fileName)}
                            </span>
                          </div>
                        ))
                      ) : (
                        <span className="text-muted">—</span>
                      )}

                      <div className="mt-3">
                        <div className="scans-fontweight500">Notes</div>
                        <div
                          style={{
                            maxHeight: "100px",
                            overflowY: "auto",
                            paddingRight: "4px",
                            lineHeight: "1.5",
                            scrollbarWidth: "thin", // Firefox
                          }}
                        >
                          {toothDetails?.[0]?.note || "—"}
                        </div>
                      </div>

                      <div className="mt-3">
                        <div className="scans-fontweight500">File</div>
                        <div className="file-partdesign">
                          {toothDetails?.[0]?.filePath ? (
                            <a
                              href={`${API_PATH}${toothDetails[0].filePath}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              title={toothDetails[0].fileName}
                            >
                              {toothDetails[0].fileName}
                            </a>
                          ) : (
                            "—"
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {activeModalTab === "scan" && (

                  <>

                    <ModelViewer
                      files={convertToModelViewerFiles(selectedOrder?.filesList || [])}
                      scanUrl={toothDetails?.[0]?.scanUrl}
                      onDelete={() => { }}
                    />

                  </>
                )}

                {activeModalTab === "actions" && (
                  <>
                    {actionView === null && (
                      <div className="p-3">

                        {/* 1️⃣ ACCEPT / REJECT → ONLY BEFORE DESIGN */}
                        {isAwaitingAcceptance && (
                          <>
                            <ul className="report-delay-list-action">
                              <li onClick={() => setActionView("accept")}>
                                Accept & Proceed
                              </li>
                            </ul>

                            <ul className="report-delay-list-action">
                              <li onClick={() => setActionView("reject-scan")}>
                                Reject Scan
                              </li>
                            </ul>
                            <ul className="report-delay-list-action">
                              <li onClick={() => setActionView("reject-order")}>
                                Reject Order
                              </li>
                            </ul>
                          </>
                        )}

                        {(isInDesign || isDelayReport || IsOverdue) && (
                          <>
                            {Object.keys(designFiles).length > 0 ? (
                              <button
                                className="btn report-dealybottom-text w-100"
                                disabled={isSubmitting}
                                onClick={handleCompleteOrder}
                              >
                                {isSubmitting ? "Processing..." : "Complete Order"}
                              </button>
                            ) : (
                              <div className="text-center text-muted mt-1">

                              </div>
                            )}
                            {isInDesign && !isDelayReport && !showReportDelayUI && (
                              <button
                                className="btn report-dealybottom-text w-100 mt-2"
                                onClick={() => setShowReportDelayUI(true)}
                              >
                                Report Delay
                              </button>
                            )}

                            {(isInDesign || isReUploadScan) && showReportDelayUI && (
                              <div className="rounded mt-3">
                                <div className="d-flex align-items-center px-2 pb-3 border-bottom">
                                  <span
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      setShowReportDelayUI(false);
                                      setIssueText("");
                                      setReportDelayDateTime(null);
                                    }}
                                  >
                                    Back
                                  </span>
                                  <h6 className="ms-auto me-auto mb-0">Report Delay</h6>
                                </div>

                                <div className="mt-2">
                                  <label className="form-label">Enter Issue Details</label>
                                  <textarea
                                    className="form-control mb-3"
                                    rows={3}
                                    value={issueText}
                                    onChange={(e) => setIssueText(e.target.value)}
                                    placeholder="Describe the issue"
                                  />
                                </div>

                                <label className="form-label mb-2">
                                  Select Expected Date & Time
                                </label>

                                <div className="position-relative mb-3">
                                  <DatePicker
                                    selected={reportDelayDateTime}
                                    onChange={(date) => setReportDelayDateTime(date)}
                                    showTimeSelect
                                    timeFormat="HH:mm"
                                    timeIntervals={15}
                                    dateFormat="dd/MM/yyyy h:mm aa"
                                    minDate={new Date()}
                                    className="form-control"
                                    placeholderText="Select date & time"
                                  />
                                  <i
                                    className="bi bi-calendar3"
                                    style={{
                                      position: "absolute",
                                      right: "15px",
                                      top: "50%",
                                      transform: "translateY(-50%)",
                                      pointerEvents: "none",
                                      color: "#6c757d",
                                    }}
                                  ></i>
                                </div>

                                <button
                                  className="btn btn-primary"
                                  disabled={!issueText.trim() || !reportDelayDateTime || actionLoading}
                                  onClick={handleReportDelay}
                                >
                                  {actionLoading ? "Processing..." : "Confirm Report Delay"}
                                </button>
                              </div>
                            )}
                          </>
                        )}


                        {isReUploadScan && !showReportDelayUI && (
                          <>
                            {Object.keys(designFiles).length > 0 ? (
                              <button
                                className="btn report-dealybottom-text w-100"
                                disabled={isSubmitting}
                                onClick={handleReUploadScan}
                              >
                                {isSubmitting ? "Processing..." : "Re-Upload Scan"}
                              </button>
                            ) : (
                              <div className="text-center text-muted mt-3">
                                Upload files to re-upload scan
                              </div>
                            )}

                            {/* <button
                              className="btn report-dealybottom-text w-100 mt-2"
                              onClick={() => setShowReportDelayUI(true)}
                            >
                              Report Delay
                            </button> */}
                          </>
                        )}

                        {/* 3️⃣ NO ACTIONS */}
                        {!isAwaitingAcceptance && !isInDesign && !isReUploadScan && !isDelayReport && !IsOverdue && (
                          <div className="text-center text-muted">
                            No actions available for this status
                          </div>
                        )}

                      </div>

                    )}


                    {/* ACCEPT SCAN */}
                    {actionView === "accept" && (
                      <div className="report-delay-container">
                        <div className="d-flex align-items-center px-3 py-2 mx-2 border-bottom">
                          <span
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              setActionView(null);
                              setSelectedCheckBoxes([]);
                              setSelectedRejectionReasons([]);
                              setRejectionNotes("");
                            }}
                          >
                            Back
                          </span>
                          <h6 className="ms-auto me-auto mb-0">Accept Scan</h6>
                        </div>

                        <div className="p-3">
                          <div className="fw-semibold selectreasons">Checklist</div>

                          <div className="content-inside-borderbody2">
                            {loadingCheckBoxes ? (
                              <div className="text-center p-3">
                                <div className="spinner-border spinner-border-sm" role="status">
                                  <span className="visually-hidden">Loading...</span>
                                </div>
                                <p className="mt-2 small">Loading checklist...</p>
                              </div>
                            ) : checkBoxList.length === 0 ? (
                              <div className="alert alert-warning">
                                No checklist items available
                              </div>
                            ) : (
                              <ul className="model-analysis-list2">
                                {checkBoxList.map(item => (
                                  <li key={item.checkBoxID}>
                                    <label className="custom-checkbox-new-action">
                                      <div className="checkbox-text">
                                        {item.checkBoxName}
                                        {item.isRequired && (
                                          <span style={{ color: "red", marginLeft: 4 }}>*</span>
                                        )}
                                      </div>
                                      <input
                                        type="checkbox"
                                        checked={selectedCheckBoxes.includes(item.checkBoxID)}
                                        onChange={() => handleCheckBoxChange(item.checkBoxID)}
                                      />
                                    </label>
                                  </li>
                                ))}
                              </ul>
                            )}
                          </div>

                          <div className="btn-section-center">
                            <button
                              className="btn report-dealybottom-text w-100"
                              onClick={async () => {
                                if (selectedCheckBoxes.length === 0) {
                                  toast.error("Please select at least one checklist item");
                                  return;
                                }

                                if (!selectedOrder?.caseID) {
                                  toast.error("Case ID is missing");
                                  return;
                                }

                                try {
                                  const success = await acceptOrderForDesign(selectedOrder.caseID);

                                  if (success) {
                                    setTimeout(() => {
                                      const modalEl = document.getElementById("orderDetailsModal");
                                      if (modalEl) {
                                        const modal = Modal.getInstance(modalEl) || new Modal(modalEl);
                                        modal.hide();
                                      }
                                    }, 200);

                                    setActionView(null);
                                    setActiveModalTab("order-review");

                                    const ordersData = await fetchAllOrders();
                                    setOrders(ordersData);

                                    const updatedOrder = ordersData.find(
                                      o => o.caseID === selectedOrder.caseID
                                    );
                                    if (updatedOrder) {
                                      setSelectedOrder({
                                        ...selectedOrder,
                                        status: updatedOrder.centralHubDesignerTag ?? selectedOrder.status,
                                      });
                                    }
                                  }


                                } catch (error) {
                                  console.error("Error accepting design:", error);
                                  toast.error("Failed to accept scan");
                                }
                              }}
                            >
                              Accept Scan
                            </button>

                          </div>

                        </div>
                      </div>
                    )}

                    {/* REJECT SCAN */}
                    {actionView === "reject-scan" && (
                      <div className="report-delay-container">
                        <div className="d-flex align-items-center px-3 py-2 mx-2 border-bottom">
                          <span
                            style={{ cursor: "pointer", fontSize: "15px", fontWeight: "500" }}
                            onClick={() => {
                              setActionView(null);
                              setSelectedCheckBoxes([]);
                              setSelectedRejectionReasons([]);
                              setRejectionNotes("");
                            }}
                          >
                            Back
                          </span>
                          <h6 className="ms-auto me-auto mb-0 selectreasons">Reject Scan</h6>
                        </div>

                        <div className="p-3">
                          <div className="fw-semibold selectreasons">Select Reasons</div>

                          <div className="content-inside-borderbody2">
                            {loadingReasons ? (
                              <div className="text-center p-3">
                                <div className="spinner-border spinner-border-sm" role="status">
                                  <span className="visually-hidden">Loading...</span>
                                </div>
                                <p className="mt-2 small">Loading rejection reasons...</p>
                              </div>
                            ) : rejectionReasons.length === 0 ? (
                              <div className="alert alert-warning">
                                No rejection reasons available
                              </div>
                            ) : (
                              <>
                                <ul className="model-analysis-list2">
                                  {rejectionReasons.map(reason => (
                                    <li key={reason.rejectionReasonID}>
                                      <label className="custom-checkbox-new-action">
                                        <span className="checkbox-text">
                                          {reason.reasonName}
                                        </span>
                                        <input
                                          type="checkbox"
                                          checked={selectedRejectionReasons.includes(reason.rejectionReasonID)}
                                          onChange={() => handleRejectionReasonChange(reason.rejectionReasonID)}
                                        />
                                      </label>
                                    </li>
                                  ))}
                                </ul>
                              </>
                            )}
                          </div>

                          <div className="btn-section-center mt-3">
                            <button
                              className="btn btn-primary"
                              onClick={handleRejectScan}
                              disabled={loadingReasons || (selectedRejectionReasons.length === 0 && !rejectionNotes.trim())}
                            >
                              {loadingReasons ? "Loading..." : "Reject Scan"}
                            </button>
                          </div>

                        </div>

                      </div>
                    )}

                    {/* REJECT ORDER */}
                    {actionView === "reject-order" && (
                      <div className="report-delay-container">
                        <div className="d-flex align-items-center px-3 py-2 mx-2 border-bottom">
                          <span
                            style={{ cursor: "pointer", fontSize: "15px", fontWeight: "500" }}
                            onClick={() => {
                              setActionView(null);
                              setSelectedCheckBoxes([]);
                              setSelectedRejectionReasons([]);
                              setRejectionNotes("");
                            }}
                          >
                            Back
                          </span>
                          <h6 className="ms-auto me-auto mb-0 selectreasons">
                            Reject Order
                          </h6>
                        </div>

                        <div className="p-3 ">
                          <div className="fw-semibold selectreasons mb-2">
                            Enter Rejection Reason
                          </div>

                          <textarea
                            className="form-control"
                            rows={4}
                            placeholder="Enter reason for rejecting this order..."
                            value={rejectionNotes}
                            onChange={(e) => setRejectionNotes(e.target.value)}
                          />

                          <div className="btn-section-center mt-3">
                            <button
                              className="btn btn-secondary py-2"
                              onClick={handleRejectOrder}
                              disabled={!rejectionNotes.trim()}
                            >
                              Reject Order
                            </button>
                          </div>
                        </div>
                      </div>
                    )}

                  </>
                )}
              </div>
            </div>
          </div>
        </div>

        {showQueryModal && (
          <div
            className="modal fade show d-block"
            tabIndex={-1}
            style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
          >
            <div className="modal-dialog modal-lg modal-dialog-centered">
              <div className="modal-content">

                <div className="modal-header">
                  <h5 className="modal-title">
                    Order Query - {selectedOrder?.orderId}
                  </h5>

                  <button
                    type="button"
                    className="btn-close"
                    onClick={closeQueryModal}
                  />
                </div>

                <div className="modal-body">
                  <div className="chat-container premium-card chat-card shadow-sm">

                    <div className="chat-header">
                      <span>
                        Order ID : {selectedOrder?.orderId}
                      </span>
                    </div>

                   <div
  ref={chatBodyRef}
  className="chat-body"
  style={{
    minHeight: "13px",
    maxHeight: "422px",
    overflowY: "auto",
  }}
>
                      {messages.length > 0 ? (
                        messages.map((msg) => (
                          <div
                            key={msg.id}
                            className={`chat-message ${msg.senderType === "Designer"
                              ? "sent"
                              : "received"
                              }`}
                          >
                            <div className="chat-bubble">

                              {msg.message && (
                                <>
                                  {msg.message.length > 150 ? (
                                    <>
                                      {expandedMessages[msg.id]
                                        ? msg.message
                                        : `${msg.message.substring(0, 150)}...`}

                                      <div>
                                        <span
                                          style={{
                                            cursor: "pointer",
                                            color: "#0d6efd",
                                            fontSize: "12px",
                                            fontWeight: 500,
                                          }}
                                          onClick={() =>
                                            toggleMessage(msg.id)
                                          }
                                        >
                                          {expandedMessages[msg.id]
                                            ? "View Less"
                                            : "View More"}
                                        </span>
                                      </div>
                                    </>
                                  ) : (
                                    msg.message
                                  )}
                                </>
                              )}

                              {msg.filePath && (
                                <div className="mt-2">
                                  <a
                                    href={`${API_PATH}/uploads/chat/${msg.filePath}`}
                                    target="_blank"
                                    rel="noreferrer"
                                  >
                                    📎 View Attachment
                                  </a>
                                </div>
                              )}

                              {/* Timestamp */}
  {msg.createdDate && (
    <div className="text-end mt-2">
      <small style={{ color: "#6c757d", fontSize: "11px" }}>
        {new Date(msg.createdDate).toLocaleString("en-GB")}
      </small>
    </div>
  )}

                            </div>
                          </div>
                        ))
                      ) : (
                        <div className="text-center text-muted py-5">
                          No messages found.
                        </div>
                      )}
                    </div>

                    <div className="chat-footer">
                      <div className="chat-footer">

                        {/* FILE PREVIEW (TOP AREA) */}
                        {selectedFile && (
                          <div className="mb-2 border rounded p-2 position-relative bg-light d-inline-block">

                            {previewUrl ? (
                              <img
                                src={previewUrl}
                                alt="Preview"
                                style={{
                                  maxWidth: "180px",
                                  maxHeight: "140px",
                                  objectFit: "cover",
                                  borderRadius: "8px",
                                  display: "block",
                                }}
                              />
                            ) : (
                              <div className="d-flex align-items-center gap-2">
                                <i className="bi bi-paperclip"></i>
                                <span>{selectedFile.name}</span>
                              </div>
                            )}

                            <button
                              type="button"
                              className="btn btn-sm btn-danger position-absolute top-0 end-0 m-1"
                              onClick={() => {
                                setSelectedFile(null);
                                setPreviewUrl("");
                              }}
                            >
                              ×
                            </button>

                          </div>
                        )}

                        {/* INPUT + ACTIONS ROW */}
                        <div className="d-flex gap-2 align-items-center">

                          <input
                            type="text"
                            className="form-control"
                            placeholder="Type a message..."
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") sendMessage();
                            }}
                          />

                          {/* HIDDEN FILE INPUT */}
                          <input
  type="file"
  hidden
  id="chatFile"
  onChange={(e) => {
    const file = e.target.files?.[0];

    if (file) {
      setSelectedFile(file);

      if (file.type.startsWith("image/")) {
        setPreviewUrl(URL.createObjectURL(file));
      } else {
        setPreviewUrl("");
      }
    }

    // Reset input so same file can be selected again
    e.target.value = "";
  }}
/>

                          <label
                            htmlFor="chatFile"
                            className="btn btn-outline-secondary"
                          >
                            <i className="bi bi-paperclip"></i>
                          </label>

                          <button
                            className="btn btn-primary"
                            onClick={sendMessage}
                          >
                            <i className="bi bi-send-fill"></i>
                          </button>

                        </div>

                      </div>

                      {/* {selectedFile && (
                        <div className="mt-2">
                          <small>
                            Selected File: {selectedFile.name}
                          </small>

                          <button
                            className="btn btn-sm btn-link text-danger"
                            onClick={() =>
                              setSelectedFile(null)
                            }
                          >
                            Remove
                          </button>
                        </div>
                      )} */}

                    </div>

                  </div>
                </div>

                <div className="modal-footer">
                  <button
                    className="btn btn-secondary"
                    onClick={closeQueryModal}
                  >
                    Close
                  </button>
                </div>

              </div>
            </div>
          </div>
        )}

  
    </>
  );
};

export default DashboardDesignerCentralHub;